// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1stuR","left":"styles_left__24t8H"};